import { ActionTreeWithRootState } from '~/store/types'
import { FlashState } from '~/store/modules/shared/flash/state'

export default {} as ActionTreeWithRootState<FlashState>
